import PropTypes from 'prop-types';

import LikeIcon from '@/public/icons/howToLikeIcon.svg';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import Text from '@/src/ui/text/components/Text';

import css from '../../styles/TotalLikes.module.css';

const TotalLikes = ({likesCount, isLoading, isVoted}) => {
  return (
    <div className={css.likes}>
      {isLoading ? null : (
        <>
          <LikeIcon />{' '}
          <Text color={Text.COLOR.GREY} fontSize={Text.FONT_SIZE.SIZE_12}>
            {!likesCount && isVoted && (
              <>
                <TextLocal id={'wiki-how.you-rated-this-article'} />
              </>
            )}
            {!likesCount && !isVoted && (
              <>
                <TextLocal id={'wiki-how.no-likes'} />
              </>
            )}
            {likesCount === 1 && (
              <>
                {likesCount} <TextLocal id={'wiki-how.one-likes'} />
              </>
            )}
            {likesCount > 1 && (
              <>
                {likesCount} <TextLocal id={'wiki-how.more-than-one'} />
              </>
            )}
          </Text>
        </>
      )}
    </div>
  );
};

TotalLikes.propTypes = {
  likesCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isLoading: PropTypes.bool.isRequired,
  isVoted: PropTypes.bool.isRequired,
};

TotalLikes.defaultProps = {
  likesCount: 0,
};

export default TotalLikes;
